import { request } from './client';
import type { ExternalJobMarketDatapool, ExternalJobMarketJobsResponse } from '@/types/externalJobMarket';

/**
 * fetch information about a specific datapool
 */
export function fetchExternalJobMarketDatapool(datapoolId: number): Promise<{ data: ExternalJobMarketDatapool }> {
  return request('GET', `/v1/account/external-job-market/datapool/${datapoolId}`);
}

/**
 * fetch jobs from a specific datapool
 */
export function fetchExternalJobMarketJobs(
  datapoolId: number,
  parameters?: { [key: string]: any }
): Promise<ExternalJobMarketJobsResponse> {
  return request('GET', `/v1/account/external-job-market/datapool/${datapoolId}/jobs`, parameters);
}

export function fetchAllExternalJobMarketJobs(datapoolId: number): Promise<ExternalJobMarketJobsResponse> {
  return fetchExternalJobMarketJobs(datapoolId, { page_size: 50000, page: 0 });
}
